export const firebaseConfig = {
  apiKey: "AIzaSyBmQTg0UeVgqAs5RI3WVZk_BbtYbDrYzrA",
  authDomain: "tg-web-6c300.firebaseapp.com",
  databaseURL: "https://tg-web-6c300.firebaseio.com",
  projectId: "tg-web-6c300",
  storageBucket: "tg-web-6c300.appspot.com",
  messagingSenderId: "215326572479",
  appId: "1:215326572479:web:5ef67ee481418cfde32b0a"
}



// WEBPACK FOOTER //
// ./src/api/config.js